import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

export default class UpdateCount extends Component {
  state = {
    countId: "",
    title: "",
    description: "",
    status: "active",
    is_delete: "no",

    message: "",
    notification: false,
    notiColor: "success",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getSingleCount();
  }

  getSingleCount = () => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const countId = window.location.pathname.split("/")[2];
    axios
      .get(Constants.getUrls.getAllCounts + "/" + countId)
      .then((resp) => {
        if (resp.data?.status === "success") {
          const data = resp.data.data || {};
          this.setState({
            countId: data._id,
            title: data.title || "",
            description: data.description || "",
            status: data.status || "active",
            is_delete: data.is_delete || "no",
          });
        } else {
          this.setState({
            notification: true,
            notiColor: "warning",
            message: resp.data?.message || "Failed to fetch count",
          });
        }
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Error fetching count",
        });
      });
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { countId, title, description, status, is_delete } = this.state;

    if (!title) {
      this.setState({
        notification: true,
        notiColor: "warning",
        message: "Title is required!",
      });
      setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      return;
    }

    const body = { title, description, status, is_delete };

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    this.setState({ loading: true });

    axios
      .put(Constants.putUrls.updateCount + countId, body)
      .then((resp) => {
        this.setState({
          notification: true,
          notiColor: "success",
          message: resp.data?.message || "Count updated successfully!",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "", redirect: true }), 2000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to update count",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 4000);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/count" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Count
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <TextField
                      type="text"
                      label="Title"
                      name="title"
                      onChange={this.handleInput}
                      value={this.state.title}
                      style={{ width: "100%", top: "13px" }}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Select Status</InputLabel>
                    <Select
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      name="status"
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="active" style={{ color: "#111" }}>
                        Active
                      </MenuItem>
                      <MenuItem value="inactive" style={{ color: "#111" }}>
                        Inactive
                      </MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      type="text"
                      label="Small Description"
                      name="description"
                      onChange={this.handleInput}
                      value={this.state.description}
                      style={{ width: "100%" }}
                      multiline
                      rows={4}
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Updating..." : "Update"}
                    </MDButton>
                  </Grid>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Counts Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
